<template lang="pug">
  ol.responsive-table.sheet-aggregate-list(
    v-rc-loader="loading"
    :class="{ empty: !sheetAggregates.length }"
  )
    slot(name="header")
    sheet-aggregate-tile(
      v-for="sheetAggregate in sheetAggregates"
      :key="sheetAggregate.reference.value"
      :sheetAggregate="sheetAggregate"
      :actions="actions"
      :selectable="selectable"
      :selected="selectedAggregateIds.includes(sheetAggregate.reference.value)"
      @select="toggleSheetAggregate"
      @action="emitActionEvent"
      @mouseenter.native="hoverOver(sheetAggregate)"
      @mouseleave.native="hoverOver(null)"
    )
    .no-results(v-if="!sheetAggregates.length && !loading")
      slot(name="noResults") Aucun résultat.
</template>

<script>
import SheetAggregateTile from './sheet-aggregate-tile/SheetAggregateTile.vue';
import { rcLoader } from '@/directives/rc-loader/rcLoader.js';

export default {
  name: 'SheetAggregateList',
  directives: { rcLoader },
  components: {
    SheetAggregateTile,
  },
  props: {
    sheetAggregates: {
      type: Array,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedAggregateIds: [],
      hoveringOver: null,
    };
  },
  methods: {
    toggleSheetAggregate({ selected, sheetAggregateId }) {
      if (!selected) {
        this.selectedAggregateIds = this.selectedAggregateIds.filter(it => it !== sheetAggregateId);
      } else {
        this.selectedAggregateIds = [...this.selectedAggregateIds, sheetAggregateId];
      }
      this.emitSelectionEvent();
    },
    selectAll() {
      this.selectedAggregateIds = this.sheetAggregates.map(it => it.reference.value);
      this.emitSelectionEvent();
    },
    deselectAll() {
      this.selectedAggregateIds = [];
      this.emitSelectionEvent();
    },
    emitSelectionEvent() {
      this.$emit('selection', { selected: this.selectedAggregateIds });
    },
    emitActionEvent(action) {
      this.$emit(action.event, { sheetAggregateId: action.sheetAggregateId });
    },
    hoverOver(sheet) {
      this.hoveringOver = sheet;
      this.$emit('hover', { sheet });
    },
  },
};
</script>

<style lang="scss">
  .sheet-aggregate-list {
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
    .sheet-aggregate-tile:hover {
      background: #EAEAEA;
    }
  }
</style>